export const project = [
    {
        name: "Taco bell clone",
        repository: "https://github.com/ArgoTenacius/Tacobell-clone",
        photo: "https://user-images.githubusercontent.com/94071579/156898440-25647e12-06d3-4171-a36d-c9d8b32796ea.png",
        live: "https://argotenacius.github.io/Tacobell-clone/",
        description: "For study purpose, the main page of the Taco bell website (https://www.tacobell.co.in/) was recreated with the objective of optimize it the max possible, getting a better performance of 90%."
    },
    {
        name: "Chat app",
        repository: "https://github.com/ArgoTenacius/chat-app",
        photo: "https://user-images.githubusercontent.com/94071579/178111155-b70d096c-4b46-4a0b-b500-d98577f1b49e.png",
        live: "https://argotenacius.github.io/chat-app/",
        description: "A real-time web chat application inspired by WhatsApp Web. Using firebase authentication and database, it can send and receive messages dynamically."
    },
    {
        name: "Bug tracker",
        repository: "https://github.com/ArgoTenacius/bug-tracker",
        photo: "https://user-images.githubusercontent.com/94071579/170094494-c4edc3b3-6f34-43c0-8764-53ccd79b5919.png",
        live: "https://argotenacius.github.io/bug-tracker/",
        description: "With firebase in mind as the database, the project was made to learn how to apply, get, delete, move and add database info, getting in result an authentication system and a dynamic data management."
    },
]